import { Button } from '@/components/ui/button';
import { parseCloseHeld } from '../api/portfolioSyncStats';

/**
 * Aviso de la ultima sincronizacion. Cuando Setup deja de informar buena parte de la
 * cartera, el sistema no cierra esas deudas por su cuenta: lo muestra aca y espera que
 * alguien confirme.
 */
export function PortfolioSyncWarning({
  message,
  stats,
  busy,
  onConfirmClose,
}: {
  message: string | null | undefined;
  stats: Record<string, unknown> | null | undefined;
  busy: boolean;
  onConfirmClose: () => void;
}) {
  const text = message?.trim() ?? '';
  const held = parseCloseHeld(stats);
  if (!text && !held) {
    return null;
  }
  return (
    <div
      role='alert'
      className='rounded-xl border border-amber-300 bg-amber-50 p-4 text-sm dark:border-amber-800 dark:bg-amber-950/40'
    >
      {held ? (
        <>
          <p className='font-medium text-amber-900 dark:text-amber-100'>
            No se cerraron {held.wouldClose} de {held.open} facturas abiertas
          </p>
          <p className='mt-1 text-amber-800/80 dark:text-amber-200/80'>
            Setup dejó de informarlas en la última sincronización. Si de verdad se pagaron, confirmá el cierre. Si
            no, revisá la conexión y la empresa configurada.
          </p>
          <Button
            type='button'
            variant='outline'
            size='sm'
            className='mt-3'
            disabled={busy}
            onClick={onConfirmClose}
          >
            Confirmar el cierre de {held.wouldClose} facturas
          </Button>
        </>
      ) : (
        <p className='text-amber-900 dark:text-amber-100'>{text}</p>
      )}
    </div>
  );
}
